"use client";

import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/tabs";
import { Inbox, Briefcase, FileText, Settings } from "lucide-react";

interface AdminTabsProps {
  messagesContent: React.ReactNode;
  projectsContent: React.ReactNode;
  blogContent: React.ReactNode;
}

export function AdminTabs({ messagesContent, projectsContent, blogContent }: AdminTabsProps) {
  return (
    <Tabs defaultValue="messages" className="w-full">
      <TabsList className="grid w-full grid-cols-3 mb-8 bg-neutral-900/50 border border-neutral-800 p-1 rounded-2xl">
        <TabsTrigger value="messages" className="flex items-center gap-2 py-3 rounded-xl data-[state=active]:bg-violet-600 data-[state=active]:text-white">
          <Inbox size={18} />
          <span className="hidden sm:inline">Messages</span>
        </TabsTrigger>
        <TabsTrigger value="projects" className="flex items-center gap-2 py-3 rounded-xl data-[state=active]:bg-fuchsia-600 data-[state=active]:text-white">
          <Briefcase size={18} />
          <span className="hidden sm:inline">Projects</span>
        </TabsTrigger>
        <TabsTrigger value="blog" className="flex items-center gap-2 py-3 rounded-xl data-[state=active]:bg-cyan-600 data-[state=active]:text-white">
          <FileText size={18} />
          <span className="hidden sm:inline">Blog</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="messages" className="mt-0 focus-visible:ring-0">
        {messagesContent}
      </TabsContent>
      <TabsContent value="projects" className="mt-0 focus-visible:ring-0">
        {projectsContent}
      </TabsContent>
      <TabsContent value="blog" className="mt-0 focus-visible:ring-0">
        {blogContent}
      </TabsContent>
    </Tabs>
  );
}